import { Component } from 'solid-js'
import { CharacterSchema } from '../CharacterSchema'
import { CharEditor } from '../editor'
import { MemoryBookPicker } from './MemoryBookPicker'
import { Card } from '/web/shared/Card'
import RangeInput from '/web/shared/RangeInput'
import TextInput from '/web/shared/TextInput'
import { i18nStore } from '../../../store'

export const AdvancedOptions: Component<{ editor: CharEditor }> = (props) => {
  const i18n = i18nStore((s) => s)
  return (
    <>
      <Card class="flex flex-col gap-2">
        <CharacterSchema
          characterId={props.editor.state.editId}
          update={(next) => props.editor.update('json', next)}
        />
        <TextInput
          isMultiline
          fieldName="systemPrompt"
          label={i18n.t.char_systemPrompt}
          helperText={
            <span>
              {i18n.t.char_systemPromptHelper}
            </span>
          }
          placeholder={i18n.t.char_systemPromptPlaceholder}
          value={props.editor.state.systemPrompt}
          onChange={(ev) => props.editor.update('systemPrompt', ev.currentTarget.value)}
        />
        <TextInput
          isMultiline
          fieldName="postHistoryInstructions"
          label={i18n.t.char_jailbreak}
          helperText={
            <span>
              {i18n.t.char_jailbreakHelper}
            </span>
          }
          placeholder={i18n.t.char_jailbreakPlaceholder}
          value={props.editor.state.postHistoryInstructions}
          onChange={(ev) => props.editor.update('postHistoryInstructions', ev.currentTarget.value)}
        />
        <TextInput
          isMultiline
          class="min-h-[80px]"
          fieldName="insertPrompt"
          label={i18n.t.char_insertDepthPrompt}
          helperMarkdown={(i18n.t.char_insertDepthPromptHelper || '').replace('{depth}', '**Insert Depth**')}
          placeholder={i18n.t.char_insert_depth_placeholder}
          value={props.editor.state.insert?.prompt}
          onChange={(ev) =>
            props.editor.update('insert', {
              prompt: ev.currentTarget.value,
              depth: props.editor.state.insert?.depth ?? 3,
            })
          }
        />
        <RangeInput
          fieldName="insertDepth"
          label={i18n.t.char_insertDepth}
          helperText={
            <>
              {i18n.t.char_insertDepthHelper} 5 {i18n.t.char_recommended}
            </>
          }
          min={0}
          max={10}
          step={1}
          value={props.editor.state.insert?.depth ?? 3}
          onChange={(ev) =>
            props.editor.update('insert', {
              prompt: props.editor.state.insert?.prompt || '',
              depth: ev,
            })
          }
        />
      </Card>
      <Card>
        <MemoryBookPicker
          setBundledBook={(book) => props.editor.update('book', book)}
          bundledBook={props.editor.state.book}
          characterId={props.editor.state.editId}
        />
      </Card>
      <Card>
        <TextInput
          fieldName="creator"
          label={i18n.t.char_creator}
          placeholder={i18n.t.char_creatorPlaceholder}
          value={props.editor.state.creator}
          onChange={(ev) => props.editor.update('creator', ev.currentTarget.value)}
        />
      </Card>
      <Card>
        <TextInput
          fieldName="characterVersion"
          label={i18n.t.char_version}
          placeholder={i18n.t.char_versionPlaceholder}
          value={props.editor.state.characterVersion}
          onChange={(ev) => props.editor.update('characterVersion', ev.currentTarget.value)}
        />
      </Card>
    </>
  )
}
